(function () {
    'use strict';
    realmCommerceApp.directive("alphanumericValidation", AlphanumericValidation);
    function AlphanumericValidation() {
        var directive = {
            link: link,
            restrict: 'A',
            require: 'ngModel',
        };
        return directive;

        function link(scope, elem, attr, ngModel) {
            var validator = function (value) {
                if (/^[a-zA-Z0-9]*$/.test(value)) {
                    ngModel.$setValidity('alphanumeric', true);
                    elem[0].setCustomValidity('');
                    return value;
                } else {
                    ngModel.$setValidity('alphanumeric', false);
                    elem[0].setCustomValidity('Password must be Alpha Numeric.');
                    return undefined;
                }
            };
            ngModel.$parsers.unshift(validator);
            ngModel.$formatters.unshift(validator);
        }
    }
})();




// WEBPACK FOOTER //
// ./static/js/app/components/alphanumericvalidation.directive.js